import { useState } from 'react'
import { router } from '@inertiajs/react'
import { ArrowRight, Loader2, RefreshCw, Square } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { isActive, investigationUrl } from '@/frontend/features/Fde/investigations/format'
import type { InvestigationLabels, InvestigationRun } from '@/frontend/features/Fde/investigations/types'

interface Props { run: InvestigationRun; projectId: string; configured: boolean; blocked: boolean; copy: InvestigationLabels }

export default function RunActions({ run, projectId, configured, blocked, copy }: Props) {
  const [busy, setBusy] = useState<string | null>(null)
  const submit = (mode: 'continuation' | 'update' | 'cancel') => {
    if (busy) return
    setBusy(mode)
    router.post(investigationUrl(projectId, run.id, mode === 'cancel' ? 'cancel' : 'follow_up'), mode === 'cancel' ? {} : { mode }, {
      preserveScroll: true, onFinish: () => setBusy(null),
    })
  }
  if (run.stop_status === 'pending') return null
  if (isActive(run.status) || run.stop_status === 'failed') return <Button size="sm" variant="outline" disabled={Boolean(busy)} onClick={() => submit('cancel')}>
    {busy ? <Loader2 className="size-3.5 animate-spin" aria-hidden /> : <Square className="size-3" aria-hidden />}{run.stop_status === 'failed' ? copy.cancel_retry : copy.cancel}
  </Button>
  return <div className="flex flex-wrap gap-2" title={blocked ? copy.active_run : undefined}>
    <Button size="sm" variant="outline" disabled={Boolean(busy) || !configured || blocked} title={copy.continue_hint} onClick={() => submit('continuation')}>
      {busy === 'continuation' ? <Loader2 className="size-3.5 animate-spin" aria-hidden /> : <ArrowRight className="size-3.5" aria-hidden />}{copy.continue}
    </Button>
    <Button size="sm" variant="ghost" disabled={Boolean(busy) || !configured || blocked} title={copy.update_hint} onClick={() => submit('update')}>
      {busy === 'update' ? <Loader2 className="size-3.5 animate-spin" aria-hidden /> : <RefreshCw className="size-3.5" aria-hidden />}{copy.update}
    </Button>
  </div>
}
